import {
  isAureaActiveClient,
  isBfacmActiveClient,
  isBpcActiveClient,
  isBvalorActiveClient,
  isHemeraActiveClient,
  isStinvestActiveClient,
} from '»utils/clientsUtils';

import { FooterAurea } from './Aurea';
import { FooterBFACM } from './BFACM';
import { FooterBPC } from './BPC';
import { FooterBancoValor } from './BVALOR';
import { FooterFinantech } from './Finantech';
import { FooterContainer, FooterInnerContainer } from './Footer.styles';
import { FooterHemera } from './Hemera';
import { FooterStandard } from './Standard';

export const Footer = () => {
  const getClientsFooter = () => {
    if (isAureaActiveClient) return <FooterAurea />;

    if (isHemeraActiveClient) return <FooterHemera />;

    if (isBfacmActiveClient) return <FooterBFACM />;

    if (isStinvestActiveClient) return <FooterStandard />;

    if (isBpcActiveClient) return <FooterBPC />;

    if (isBvalorActiveClient) return <FooterBancoValor />;

    return <FooterFinantech />;
  };

  return (
    <FooterContainer>
      <FooterInnerContainer>{getClientsFooter()}</FooterInnerContainer>{' '}
    </FooterContainer>
  );
};
